// ============================================================
//  BERANI VIP SKYBOX CATERING – zdrojová data
//  Snadno rozšiřitelné: přidávejte / upravujte balíčky a zápasy
// ============================================================

export const PACKAGES = [
  {
    id: 'seafood-executive',
    code: '01',
    name: 'Seafood Executive Lounge',
    tagline: 'Prémiový mořský catering pro nejnáročnější VIP hosty',
    persons: '4 osoby',
    price: 2790,
    accent: '#0EA5E9',
    food: [
      '250 g Losos s kůží v krémové bylinkové omáčce',
      '200 g Tygří krevety Aglio Olio na česneku a chilli',
      '150 g Grissini tyčinky se sušenou šunkou a marascon olivami',
      '200 g Domácí Focaccia a rozpečené pečivo',
      '6 ks Mini tartaletky s mascarpone a ovocem (cca 180 g)',
    ],
    drinks: [
      '3× Prosecco Treviso 0,75 l',
      '4× Minerální voda 0,75 l',
      '6× Cappy džus 0,25 l',
    ],
  },
  {
    id: 'beef-wine',
    code: '02',
    name: 'Executive Beef & Wine Board',
    tagline: 'Prvotřídní hovězí speciality doplněné moravským vínem',
    persons: '4 osoby',
    price: 2990,
    accent: '#B91C1C',
    food: [
      '300 g Hovězí tatarák',
      '200 g Křupavé topinky a focaccia',
      '200 g Sous-vide Roastbeef na tenké plátky s lanýžovou majonézou',
      '300 g Trhané hovězí Pulled Beef na mini toastících',
      '6 ks Mix mini větrníčků a brownies (cca 180 g)',
    ],
    drinks: [
      '3× Moravské jakostní víno 0,75 l',
      '4× Minerální voda 0,75 l',
      '4× Cappy džus 0,25 l',
    ],
  },
  {
    id: 'street-nachos',
    code: '03',
    name: 'Executive Street Food & Nachos',
    tagline: 'Moderní streetfood s hokejovou atmosférou',
    persons: '4 osoby',
    price: 2590,
    accent: '#F59E0B',
    food: [
      '6× Mini Angus Burger v brioche bulce',
      '400 g Křupavé kuřecí stripsy Crunchy s dipem',
      '250 g Kukuřičné Nachos',
      '150 g Teplá cheddarová omáčka',
      '6 ks Mini čokoládové muffiny / brownies (cca 180 g)',
    ],
    drinks: [
      '12× Plzeňský Prazdroj 0,5 l',
      '4× Birell nealko 0,5 l',
      '6× Kofola 0,5 l',
      '4× Minerální voda 0,75 l',
    ],
  },
  {
    id: 'vip-bbq',
    code: '04',
    name: 'VIP BBQ & Meat Lounge',
    tagline: 'Grilované masové pochoutky pro pravé fanoušky',
    persons: '4 osoby',
    price: 2590,
    accent: '#7C2D12',
    food: [
      '1 000 g Hovězí sous-vide žebra v BBQ glazuře',
      '400 g Mini grilované klobásky na rozmarýnu',
      '400 g Zlatavé mini bramboráčky',
      '200 g Focaccia / chléb',
      'Hořčice, Křen, Kyselé okurky',
      '6 ks Mini cheesecake bites (cca 180 g)',
    ],
    drinks: [
      '12× Plzeňský Prazdroj 0,5 l',
      '4× Birell nealko 0,5 l',
      '4× Kofola 0,5 l',
      '4× Minerální voda 0,75 l',
    ],
  },
  {
    id: 'berani-pub',
    code: '05',
    name: 'Berani Pub & Fry Lounge',
    tagline: 'Klasická hospodská nabídka v prémiovém provedení',
    persons: '4 osoby',
    price: 1990,
    accent: '#10B981',
    food: [
      '400 g Mini kuřecí řízečky v trojobalu',
      '300 g Smažené mini hermelínky / Gouda bites',
      '400 g Mix kuřecích stripsů a sýrových Jalapeños papriček',
      '250 g Focaccia a čerstvý chléb',
      'Domácí tatarka, Česnekový dresink, Okurky',
      '6 ks Mini koblížky plněné slaným karamelem nebo čokoládou',
    ],
    drinks: [
      '14× Plzeňský Prazdroj 0,5 l',
      '6× Kofola 0,5 l',
      '4× Minerální voda 0,75 l',
    ],
  },
];

// Domácí zápasy – snadno rozšiřitelné (přidejte další zápasy do pole)
export const MATCHES = [
  { id: 1, round: '1. kolo', date: '2026-09-09', day: 'Středa', time: '17:30', opponent: 'Piráti Chomutov' },
  { id: 2, round: '3. kolo', date: '2026-09-13', day: 'Neděle', time: '16:00', opponent: 'HC ZUBR Přerov' },
  { id: 3, round: '5. kolo', date: '2026-09-23', day: 'Středa', time: '17:30', opponent: 'HC Tábor' },
  { id: 4, round: '8. kolo', date: '2026-09-30', day: 'Středa', time: '17:30', opponent: 'SK Horácká Slavia Třebíč' },
  { id: 5, round: '10. kolo', date: '2026-10-07', day: 'Středa', time: '17:30', opponent: 'SC Marimex Kolín' },
  { id: 6, round: '12. kolo', date: '2026-10-14', day: 'Středa', time: '17:30', opponent: 'HC Baník Sokolov' },
  { id: 7, round: '17. kolo', date: '2026-10-21', day: 'Středa', time: '17:30', opponent: 'HC Slavia Praha' },
  { id: 8, round: '15. kolo', date: '2026-10-26', day: 'Pondělí', time: '16:00', opponent: 'HC Frýdek-Místek' },
  { id: 9, round: '19. kolo', date: '2026-10-31', day: 'Sobota', time: '16:00', opponent: 'HC Dukla Jihlava' },
];

export const CATERING_INFO = {
  provider: 'VšeProAkci s.r.o.',
  email: 'catering@vseproakci.cz',
  minDaysBeforeMatch: 5,
  minPersons: 4,
  maxPersons: 4,
  fixedPersons: 4,
};

export const formatCzechDate = (isoDate) => {
  const d = new Date(isoDate);
  return `${d.getDate()}. ${d.getMonth() + 1}. ${d.getFullYear()}`;
};

export const fmtPrice = (n) =>
  n.toLocaleString('cs-CZ') + ' Kč';
